import { createApp } from 'vue'
import $ from 'jquery'
import VideoPlayer from "./components/video_markup_player.vue"
import AudioPlayer from "./components/audio_markup_player.vue"

export function initMediaAsset(element) {
  const $el = $(element)
  const resourceId = $('.media-markup-data', $el).data('id')
  const type = $('.media-markup-data', $el).data('type')

  const xhrData = {
    url: '/markup_attachments/asset_info/' + resourceId,
    type: 'GET',
    dataType: 'json',
    showPreloader: false
  }

  const callbacks = {
    afterSuccess: (response) => {
      if ($el.closest(document.documentElement).length) { // create app only if the element is in DOM
        const el = $el.find('.media-markup-show').get(0)
        createApp(player(type), { mediafile: response, canEdit: canEdit() }).mount(el)
      }
    }
  };

  SOPHIA.sendXHR(xhrData, callbacks)
}

function player(type) {
  if (type == 'video') {
    return VideoPlayer
  } else {
    return AudioPlayer
  }
}

function canEdit() {
  if ($('#can-edit').length > 0) {
    return $('#can-edit').data('editable')
  } else {
    return true
  }
}
